import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { BookAuthorForm } from "../BookAuthorForm";
import { EditBookAuthorModalProps } from "./types";
import { useEditBookAuthorModal } from "./controller";

export const EditBookAuthorModal = React.memo(({ modalRef, onComplete }: EditBookAuthorModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditBookAuthorModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("book_contributor_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <BookAuthorForm />
    </Modal>
  );
});
